import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import {
	getPremiumPillHover,
	TitleInsurancePillData,
} from '@core/util/title-insurance';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { MatterManualTitleInsurance } from '@models/title-insurance';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TestHooks } from './premium-amount.hooks';

@Component({
	selector: 'app-premium-amount',
	templateUrl: './premium-amount.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class PremiumAmountComponent implements OnInit {
	testHooks = TestHooks;
	public premiumPillData$: Observable<TitleInsurancePillData>;
	public displayPill = 'none';
	public ICON = ICON;

	@Input() labelPosition: 'top' | 'left' = 'top';

	@ViewSelectSnapshot(SelectedMatter.titleInsurancePremium) premium: number;
	@Select(SelectedMatter.getTitleInsurance)
	titleInsurance$: Observable<MatterManualTitleInsurance>;
	@Select(SelectedMatter.getTitleInsuranceDirectionOfAmount)
	titleInsuranceDOA$: Observable<DirectionOfFeeType>;
	@SelectSnapshot(SelectedMatter.titleInsuranceCounselCredit)
	counselCredit: number;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(private matterDispatch: MatterDispatch) {}

	ngOnInit(): void {
		this.premiumPillData$ = this.titleInsuranceDOA$.pipe(
			map((titleInsuranceDOA) => getPremiumPillHover(titleInsuranceDOA)),
		);
	}

	setPremium(value: number): void {
		const premiumInclCredits = (value ?? 0) - (this.counselCredit ?? 0);
		this.matterDispatch.SetTitleInsurance(this.matterId, {
			premiumWithCounselCreditApplied: premiumInclCredits ?? 0,
			premium: value ?? 0,
		});
	}

	togglePill(_displayPill: string): void {
		this.displayPill =
			this.displayPill === _displayPill && this.displayPill !== 'none'
				? 'none'
				: _displayPill;
	}
}
